import { Country } from "../constant/country.constant";
import { BackOfficeRole } from "../enum/shared/backoffice-role.enum";
import { SelectorModel } from "../model/shared/selector.model";

export const getCountryList = (): Array<SelectorModel> => {
    return [
        {
            id: Country.All,
            text: "All"
        },
        {
            id: Country.Laos,
            text: "Laos"
        },
        {
            id: Country.Myanmar,
            text: "Myanmar"
        },
        {
            id: Country.Philippines,
            text: "Philippines"
        },
        {
            id: Country.Thailand,
            text: "Thailand"
        }
    ];
};

export const getBackOfficeRoleList = (): Array<SelectorModel> => {
    return [
        {
            id: String(BackOfficeRole.SuperUser),
            text: "Superuser"
        },
        {
            id: String(BackOfficeRole.Administrator),
            text: "Administrator"
        },
        {
            id: String(BackOfficeRole.Moderator),
            text: "Moderator"
        }
    ];
};
